import { NotMobile, useMobileValue } from "../../../../common/Responsive";
import { UnsavedChanges } from "../../profileSection/UnsavedChanges";
import { Button } from "../../../../components";
import { FormattedMessage } from "react-intl";
import React from "react";

export const SchedulerSectionFooterFormControls = ({
  hasChanges,
  discardDisabled,
  submitDisabled,
  discardChanges,
  submitChanges,
  message,
}) => {
  const buttonSize = useMobileValue("large", "medium");
  const ariaId = "save-schedule-description";

  const discardButton = () => {
    return (
      <Button
        size={buttonSize}
        color="secondary"
        disabled={discardDisabled}
        onClick={discardChanges}
      >
        <FormattedMessage id="discard" />
      </Button>
    );
  };
  const accessibilityDescription = () => {
    const messageId = message || "";

    return (
      <span aria-hidden={true} hidden={true} id={ariaId}>
        {messageId && <FormattedMessage id={messageId} />}
      </span>
    );
  };
  const unsavedChanges = () => {
    if (!message) {
      return <UnsavedChanges />;
    }

    return (
      <span className="profile-section__unsaved-changes">
        <FormattedMessage id={message} />
      </span>
    );
  };
  const saveButton = () => {
    return (
      <>
        <Button
          size={buttonSize}
          color="primary"
          disabled={submitDisabled}
          onClick={submitChanges}
          aria-describedby={ariaId}
        >
          <FormattedMessage id="save" />
        </Button>
        {hasChanges && message && accessibilityDescription()}
      </>
    );
  };

  return (
    <div className="profile-section__footer-form-controls">
      <NotMobile>{hasChanges && unsavedChanges()}</NotMobile>
      <div className="profile-section__form-controls-buttons">
        {discardButton()}
        {saveButton()}
      </div>
    </div>
  );
};
